module.exports = __webpack_public_path__ + "static/media/ux_operations_sketch.25cd7595.jpeg";